import React, { useState, useEffect, useContext } from 'react';
import { LocationContext } from '../../context/LocationContext.js';
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import KeyboardArrowUpOutlinedIcon from '@mui/icons-material/KeyboardArrowUpOutlined';
import { Menu, MenuItem, Checkbox, ListItemText } from '@mui/material';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';

export default function LocationPicker({ locs, filterStores }) {
    const [anchorEl, setAnchorEl] = useState(null);
    const [menuOpen, setMenuOpen] = useState(false)
    const { locationAccess } = useContext(LocationContext)
    const locationIds = [{ "ID": "685eed2b2e0a0108e9b6fbc1", "name": "Rush's 1" },
    { "ID": "685aec3f8e86c4a0e4e15223", "name": "Rush's 3" },
    { "ID": "685eed6d2e0a0108e9b6fd69", "name": "Rush's 4" },
    { "ID": "685eedb22e0a0108e9b6ff02", "name": "Rush's 5" },
    { "ID": "685eedfb2e0a0108e9b7009d", "name": "Rush's 6" },
    { "ID": "685eee3c2e0a0108e9b70235", "name": "Rush's 7" },
    { "ID": "685eee922e0a0108e9b703d4", "name": "Rush's 8" },
    { "ID": "685eeec92e0a0108e9b70574", "name": "Rush's 11" },
    ]
    // const [selectedLocs, setSelectedLocs] = useState(
    //     locationIds.map((loc, idx) => ({ ...loc, checked: idx === 0 }))
    // );

    const [selectedLocs, setSelectedLocs] = useState(() => {
        if (locationAccess && locationAccess?.length > 0) {
            const locId = locationIds.filter(loc => locationAccess.includes(loc.ID))
            console.log(locId)
            return locId.map((loc, idx) => ({ ...loc, checked: idx === 0 }))
        } else {
            return locationIds.map((loc, idx) => ({ ...loc, checked: idx === 0 }))
        }
    });


    useEffect(() => {
        // Initial filter when component mounts or locs prop changes
        if (locationAccess && locationAccess?.length > 0) {
            const locId = locationIds.filter(loc => locationAccess.includes(loc.ID))
            console.log(locId)
            filterStores(locId.map(loc => loc.name));
        } else {
            filterStores(locationIds.map(loc => loc.name));
        }

    }, []);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
        setMenuOpen(true)
    };

    const handleClose = () => {
        setAnchorEl(null);
        setMenuOpen(false)
    };

    const handleChange = (event, locName, index) => {
        setSelectedLocs(prev => {
            const updated = prev.map((loc, idx) => ({
                ...loc,
                checked: idx === index
            }));
            return updated;
        })
        setAnchorEl(null)
        setMenuOpen(false)
    };

    useEffect(() => {
        passLocsUp()
    }, [selectedLocs])

    const passLocsUp = () => {
        const checked = selectedLocs.filter(loc => loc.checked).map(l => l.name)
        filterStores(checked)
    }

    return (
        <div>

            <button onClick={handleClick} style={{
                width: '155px', fontSize: '.75rem', borderRadius: '5px', border: 'none', background: 'none', padding: '5px',
                fontWeight: '550', display: 'flex', alignItems: 'center', cursor: 'pointer', height: '28px',
                boxShadow: "0rem -.0625rem 0rem 0rem #b5b5b5 inset, 0rem 0rem 0rem .0625rem rgba(0, 0, 0, .1) inset, 0rem .03125rem 0rem .09375rem #FFF inset"
            }}>
                <div style={{ paddingLeft: '7px', display: 'flex', alignItems: 'center', width: '100%', gap: '2.65em' }}>
                    <div style={{ display: 'flex', gap: '.5em', alignItems: 'center' }}>
                        <div>
                            <LocationOnOutlinedIcon fontSize='small' />

                        </div>
                        <div>
                            <p style={{ margin: '0' }}>
                                {selectedLocs.filter(loc => loc.checked).map(l => l.name)}
                            </p>
                        </div>
                    </div>

                    <div >
                        {!menuOpen ?
                            <KeyboardArrowDownOutlinedIcon fontSize='small' sx={{ cursor: 'pointer' }} />
                            :
                            <KeyboardArrowUpOutlinedIcon fontSize='small' sx={{ cursor: 'pointer' }} />}
                    </div>
                </div>
            </button>

            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                sx={{
                    maxHeight: '400px',
                    '& .MuiPaper-root': { width: '150px' }
                }}
            >
                {/* <FormControl fullWidth> */}
                {/* <MenuItem>
                    <Checkbox onClick={(e) => handleChange(e, 'all', null)} checked={selectAll} />
                    <ListItemText primary={"Select all"} onClick={(e) => handleChange(e, 'all', null)} />
                </MenuItem> */}
                {selectedLocs?.map((l, index) => (
                    <MenuItem key={index}>
                        <Checkbox onClick={(e) => handleChange(e, l.name, index)} checked={l['checked']} />
                        <ListItemText primary={l.name} onClick={(e) => handleChange(e, l.name, index)} />
                    </MenuItem>
                ))}

            </Menu>


        </div>
    );
};
